meedy.controller('meedy.userListController', ['$scope', '$state', '$mdToast', '$mdDialog', '$translate', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel',
    function ($scope, $state, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel) {

        function setData() {
            $scope.users = [];
            $scope.criteria = new UserDataGridCriteria();

            $scope.columns = [
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.USER.FULL_NAME'),
                    cellTemplate: 'meedy/application/view/app/settings/user/grid-template/data-user-list-full-name.html'
                },
                {
                    field: "email",
                    displayName: $translate.instant('T.MEEDY.MODULE.USER.EMAIL')
                },
                {
                    field: "phone",
                    displayName: $translate.instant('T.MEEDY.MODULE.USER.PHONE')
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.USER.ACCESS'),
                    cellTemplate: 'meedy/application/view/app/settings/user/grid-template/data-user-list-partner-type.html'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.USER.PESEL'),
                    cellTemplate: 'meedy/application/view/app/settings/user/grid-template/data-user-list-pesel.html'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.USER.STATUS'),
                    cellTemplate: 'meedy/application/view/app/settings/user/grid-template/data-user-list-status.html'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.USER.ACTION'),
                    cellTemplate: 'meedy/application/view/app/settings/user/grid-template/data-user-list-delete-user.html'
                }
            ];

            $scope.currentState = Constant.STATE.APP.MEEDY.SETTINGS.USER.LIST;
            $scope.Constant = Constant;
        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST
            ||  userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;
        }

        function setListeners() {
            $scope.$on(Event.MEEDY.USER.USERS_AVAILABLE_FOR_LOGGED_USER.SUCCESS, function(event, dataPage) {
                $scope.users = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
            });

            $scope.$on(Event.MEEDY.USER.DELETE.SUCCESS, function(event, dataPage) {
                $scope.criteriaChanged();
            });

            $scope.$on(Event.MEEDY.USER.SEND_ACTIVATION_LINK.SUCCESS, function(event, dataPage) {
                $scope.criteriaChanged();
            });

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {

            $scope.createNewUser = function() {
                $state.go(Constant.STATE.APP.MEEDY.SETTINGS.USER.CREATE);
            };

            $scope.editUser = function(user) {
                $state.go(Constant.STATE.APP.MEEDY.SETTINGS.USER.EDIT, {id : user.id});
            };

            $scope.deleteUser = function(user) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MEEDY.MODULE.USER.USER_DELETE_CONFIRMATION'),
                    ok: $translate.instant('T.MEEDY.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.MEEDY.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    userModel.delete(user.id);
                }, function() {
                    return false;
                });
            };

            $scope.criteriaChanged = function() {
                userModel.usersAvailableForLoggedUser($scope.criteria);
            };

            $scope.sendActivationLink = function(user) {
                userModel.sendActivationLink(user.id);
            };
        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.SETTINGS');
        }

        function initialize() {
            userModel.usersAvailableForLoggedUser($scope.criteria);
            applicationModel.viewReady = true;
            applicationModel.fillViewportMode = true;
            $scope.showAddButton($scope.createNewUser);
            $scope.hideBackButton();
            $scope.resetTitle();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
